const translations = {
    configureIntervals: 'Service interval configuration'
};

export default translations;
